export default __webpack_public_path__ + "static/media/star.1189d0b9.svg";